module.exports = __webpack_public_path__ + "static/media/torno1.25f93fe3.png";